import LayoutResultados from '../../containers/LayoutResultados';
import Resultados from '../../pages/Resultados';
import Estadisticas from '../../pages/Estadisticas';
import React from 'react';
import { ThemeProvider } from 'styled-components/macro';
import { usePage } from '../../contexts/pageContext';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import Spinner from '../../components/Spinner';
import ScrollToTop from '../../components/ScrollToTop';
import Print from '../../print/Print';
import useIni from '../../hooks/useIni';
import { themes } from '../../styles/themes';
import { getNomenclatorColorsByElecName } from '../../utils/nomenclatorUtils';
import { useViewContext } from 'contexts/viewContext';

import ErrorPage from '../../components/ErrorPage/ErrorPage';
/**
 * Switch que renderiza la página correspondiente al estado de la aplicación
 */

const PageSwitch = ({ ...rest }) => {
  const pageState = usePage();
  const { view } = useViewContext();
  const ini = useIni();
  const nomenclator = useNomenclator();
  const page = pageState && pageState.urlInfo && pageState.urlInfo.page;

  const nomenclatorColors = getNomenclatorColorsByElecName(nomenclator, page);
  const customTheme = {
    color: nomenclatorColors.c,
    colorBarra: themes.colorBarra,
    colorHover: nomenclatorColors.cs,
    search: {
      background: themes.opacity,
    },
  };
  const getView = React.useMemo(() => {
    return view !== ''
      ? view === 'estadisticas'
        ? <Estadisticas nomenclator={nomenclator} />
        : <Resultados nomenclator={nomenclator}
        />
      : undefined
  }, [view, nomenclator]);

  if (pageState.isError) return <ErrorPage />;
  if (!pageState || !pageState.data) return null;
  const { id } = pageState.urlInfo;
  return (
    <>
      <Print
        id={id}
        data={pageState.data}
        nomenclator={nomenclator}
        page={page}
        ini={ini}
      />
      <div
        css={`
          @media print {
            display: none !important;
          }
        `}
      >
        <ThemeProvider theme={customTheme}>
          {view !== '' &&
            view !== 'estadisticas' ? (
            <LayoutResultados nomenclator={nomenclator}>
              <Spinner loading={pageState.isLoading} />
              {getView}
              <ScrollToTop />
            </LayoutResultados>
          ) : (
            <>
              <Spinner loading={pageState.isLoading} />
              {getView}
              <ScrollToTop />
            </>
          )
          }
        </ThemeProvider>
      </div>
    </>
  );
};

export default PageSwitch;
